import * as React from 'react';
import { SVGProps } from 'react';

const IconTranslateSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 22h-2.184l-1.223-3h-5.187l-1.222 3H10l4.913-12h2.185L22 22Zm-8.104-5h3.878L16 12l-2.104 5Z"
    />
    <path d="M14 8h-1.999l-1.516 3.414-2.829 2.828 2.83 2.83-1.415 1.413-2.829-2.829-2.828 2.83L2 17.07l2.828-2.829L2 11.414 3.414 10l2.828 2.828L9.072 10 10 8H2V6h12v2ZM10 4H6V2h4v2Z" />
  </svg>
);
export default IconTranslateSizeM;
